// Import components
import { LoadingSpinner } from "global/components/loading_ui/LoadingSpinnerAnimation";

// Import css
import "./LoadingScreen.css";



const LoadingScreen = ({

    // The loading message (display under the spinner)
    loadingMessage = "",

    // The loading sub message (display under the loading message)
    subMessage = "",
   
    // The progress percent value (between 1 - 100)
    progressPercent = null,

}) => {

   

    // Clamp progress so it always stays between 0 and 100
    const safeProgress = Math.max(0, Math.min(100, Number(progressPercent) || 0));



    return (

        <div className="popup-overlay">

            <div className="loading-screen-content">

                <LoadingSpinner />

                <br />

                {/* If there is no progress data then display the message centrally under the spinner */}
                {!progressPercent &&
                
                    <>

                        <br/>

                        <div className="save-progress-bar__message">

                            {loadingMessage}

                        </div>

                        <div className="save-progress-bar__sub-message">

                            {subMessage}

                        </div>

                    </>

                }

                {/* If there is a progressPercent data then we want to display the loading bar and messages alligned to the left */}
                {progressPercent &&

                    <>

                        <br />
                        <br />

                        {/* Main loading text */}
                        <div className="save-progress-bar__message">
                            {loadingMessage}
                        </div>

                        {/* Optional sub text */}
                        {subMessage ? (

                            <div className="save-progress-bar__sub-message">

                                {subMessage}

                            </div>

                        ) : null}

                        <br />

                        {/* Bar outer */}
                        <div className="save-progress-bar__track">

                            {/* Bar fill */}
                            <div
                                className="save-progress-bar__fill"
                                style={{ width: `${safeProgress}%` }}
                            />

                        </div>

                        {/* Percentage text */}
                        <div className="save-progress-bar__percent">

                            {safeProgress}%

                        </div>

                    </>
                }

            </div>

        </div>
    );
};

export default LoadingScreen;